const labels = {
  FaqCategories: {
    'Ref: Page title': '常見問題',
    'Ref: Missing Faq': '常見問題為空',
    'Ref: Go to home page': '轉到主頁',
  },
  FaqCategoryDetails: { 'Ref: Page title': '問題' },
};
export default labels;
